import script from "./customer.vue?vue&type=script&setup=true&lang=ts"
export * from "./customer.vue?vue&type=script&setup=true&lang=ts"

import "./customer.vue?vue&type=style&index=0&id=392a05a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392a05a4"]])

export default __exports__